import React from 'react';
import { Table, LoadingSpinner, Box } from 'edenred-ui';
import { useTranslation } from 'react-i18next';

import { IBeneficiariesTable } from '@epi-models/pages/Beneficiaries';
import { TableNoContent } from '@epi-pages/Reports/TableNoContent';

import { BeneficiariesRow } from './BeneficiariesRow';

export const BeneficiariesTable = ({
  beneficiaries,
  showDetail,
  isLoading,
  groupSettings
}: IBeneficiariesTable) => {
  const { t } = useTranslation();
  return (
    <Box pt={2} pb={6}>
      <Table id="manage-employees-table">
        {isLoading ? (
          <LoadingSpinner />
        ) : (
          <>
            <Table.Head>
              <Table.Row>
                <Table.Cell id="manage-employees-table-employee-title">
                  {t('containers.beneficiaries.table.employee')}
                </Table.Cell>
                <Table.Cell id="manage-employees-table-email-title">
                  {t('containers.beneficiaries.table.email')}
                </Table.Cell>
                <Table.Cell id="manage-employees-table-email-title">
                  {t('containers.beneficiaries.table.employment_type')}
                </Table.Cell>
                <Table.Cell id="manage-employees-table-email-title">
                  {t('containers.beneficiaries.table.benefit_group')}
                </Table.Cell>
                <Table.Cell
                  id="manage-employees-table-actions-title"
                  width="240px"
                ></Table.Cell>
              </Table.Row>
            </Table.Head>
            <Table.Body>
              {beneficiaries.length > 0 ? (
                beneficiaries.map(beneficiary => (
                  <BeneficiariesRow
                    key={beneficiary.personId}
                    beneficiary={beneficiary}
                    showDetail={showDetail}
                    groupSetting={groupSettings?.find(
                      s => s.groupId === beneficiary.groupId
                    )}
                  />
                ))
              ) : (
                <TableNoContent
                  colSpan={6}
                  text={t('containers.beneficiaries.table.no_data')}
                />
              )}
            </Table.Body>
          </>
        )}
      </Table>
    </Box>
  );
};
